import { useEffect, useRef } from "react";
import { Link, Navigate } from "react-router-dom";
import { SiteHeader } from "@/components/site/SiteHeader";
import { ContactStep } from "@/components/sell/ContactStep";
import { cleanName } from "@/components/site/EstimateCard";
import { useJourney } from "@/lib/site";
import { api, gbp, miles } from "@/lib/api";

const Summary = ({ s }) => {
  const v = s.valuation?.status === "ok" ? s.valuation : null;
  const src = v || s.manual || s.valuation;
  return (
    <aside className="panel p-4 text-sm" data-testid="journey-summary">
      <div className="flex flex-wrap items-center gap-3">
        <span className="plate-sm" data-testid="summary-registration">{src.registration}</span>
        <span className="font-medium">{miles(src.mileage)}</span>
        <Link to="/" className="link ml-auto text-sm" data-testid="summary-change-link">Change</Link>
      </div>
      {src.vehicle?.description && <p className="mt-2 font-semibold text-slate-900" data-testid="summary-vehicle">{cleanName(src.vehicle.description)}</p>}
      {v ? (
        <p className="mt-2 text-slate-700" data-testid="summary-estimate">
          Estimated value: <strong>{v.estimate.low ? `${gbp(v.estimate.low)} – ${gbp(v.estimate.high)}` : gbp(v.estimate.amount)}</strong>
          <span className="block text-xs text-slate-500">Indicative only – subject to inspection and vehicle history checks.</span>
        </p>
      ) : <p className="mt-2 text-slate-600">No instant valuation – we'll review your car personally.</p>}
    </aside>
  );
};

export default function Sell() {
  const j = useJourney();
  const s = j.state;
  const creating = useRef(false);

  useEffect(() => {
    if ((s.valuation || s.manual) && !s.draft && !creating.current) {
      creating.current = true;
      api.post("/public/drafts").then((r) => j.update({ draft: { id: r.data.draft_id, token: r.data.draft_token } }))
        .finally(() => { creating.current = false; });
    }
  }, [s.valuation, s.manual, s.draft, j]);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  if (s.submitted) return <Navigate to="/sell/sent" replace />;
  if (!s.valuation && !s.manual) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen pb-16">
      <SiteHeader />
      <main className="mx-auto grid max-w-5xl gap-6 px-4 py-6 sm:px-6 md:grid-cols-[1fr_300px] md:gap-10 md:py-10">
        <div className="min-w-0"><ContactStep /></div>
        <div className="order-first md:order-none"><Summary s={s} /></div>
      </main>
    </div>
  );
}
